<template>
  <div>
    <div class="title mb-3">INSERIMENTO RISULTATI</div>
    <div v-if="!areAllLineupsCompleted" class="cannotSendResult">
      Impossibile inviare risultati<br>
      Lineup non completo per almeno un tavolo dell'incontro
    </div>
    <div v-else-if="isTriplicateTable && !isTeamNs" class="cannotSendResult">
      Impossibile inviare risultati<br>
      <span v-if="isTriplicateTable && !isTeamNs">Impossibile inviare dati dai giocatori in E/W nei tavoli di
        triplicato</span>
    </div>
    <div v-else>
      <b-container v-if="missingBoards.length > 0">
        <b-row>
          <b-col class="align-items-center" style="font-size: 9vw;">
            <div v-if="currentBoard !== null" class="mb-3">
              <deal-status :number="currentBoard" :small="true" style="width: 20vw; margin: auto;"></deal-status>
            </div>
            <contract :contract="currentContract" class="mb-2"></contract>
            <br>
            <span v-if="currentContract.leadRank !== null">Att. </span>
            <span v-if="currentContract.leadRank !== null">{{ currentContract.leadRank }}</span>
            <span v-if="currentContract.leadSuit !== null" v-html="convertedLeadSuit" class="lead"></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col ref="keyboardContainer" :cols="12">
            <form-wizard ref="wizard">
              <tab-content>
                {{ $t('sendResult.boardNumber') }}
                <select-with-buttons :options="missingBoards" @click="changeCurrentBoard"></select-with-buttons>
              </tab-content>
              <tab-content>
                Seleziona il livello del contratto
                <select-contract-level @click="el => changeCurrentContract('level', el)"/>
                <b-button class="my-3" variant="danger" @click="back('boardNumber')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                Seleziona il seme del contratto
                <select-suit show-nt @click="el => changeCurrentContract('suit', el)"></select-suit>
                <b-button class="my-3" variant="danger" @click="back('level')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                Liscio, contrato o sucontrato?
                <select-double @click="el => changeCurrentContract('dbl', el)"></select-double>
                <b-button class="my-3" variant="danger" @click="back('suit')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                Seleziona il dichiarante
                <select-player @click="el => changeCurrentContract('declarer', el)"></select-player>
                <b-button class="my-3" variant="danger" @click="back('dbl')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                Seleziona l'attacco
                <select-rank @click="el => changeCurrentContract('leadRank', el)"></select-rank>
                <b-button class="my-3" variant="danger" @click="back('declarer')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                Seleziona l'attacco
                <select-suit @click="el => changeCurrentContract('leadSuit', el)"></select-suit>
                <b-button class="my-3" variant="danger" @click="back('leadRank')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                <select-with-buttons :options="availableResults"
                                     @click="el => changeCurrentContract('tricks', el)"></select-with-buttons>
                <b-button class="my-3" variant="danger" @click="back('leadSuit')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
              </tab-content>
              <tab-content>
                <b-container>
                  <b-row>
                    <b-col :class="{
                      'scoreResumeForNS': currentScore > 0,
                      'scoreResumeForEW': currentScore < 0,
                      'scoreResumePass': currentScore === 0,
                      'text-center': true,
                      'scoreResume': true
                    }" cols="12">{{ currentScore }}
                    </b-col>
                  </b-row>
                </b-container>
                <b-button class="my-3 button" variant="danger" @click="back('tricks')"><span
                    class="mr-2 backButton">&#10140;</span>{{ $t('sendResult.back') }}
                </b-button>
                <br>
                <b-button class="my-3 button" variant="success" @click="sendResultToServer"
                          v-if="!confirmationTimeoutRunning"><span
                    class="mr-2">&#10004;</span>{{ $t('sendResult.send') }}
                </b-button>
                <b-button class="my-3 button" variant="warning" v-else>{{ $t('sendResult.wait') }}</b-button>
              </tab-content>
            </form-wizard>
          </b-col>
        </b-row>
        <b-overlay :show="isSending" no-wrap>
          <template #overlay>
            <div class="text-center">
              <b-icon icon="envelope" font-scale="3" animation="cylon"></b-icon>
            </div>
          </template>
        </b-overlay>
      </b-container>
      <div v-else>Nessun board da inviare</div>
    </div>
  </div>
</template>

<script>
import SelectWithButtons from '../components/lib/SelectWithButtons';
import SelectSuit from '../components/bridgeSelection/SelectSuit';
import SelectContractLevel from '../components/bridgeSelection/SelectContractLevel';
import {mapActions, mapGetters} from 'vuex';
import Contract from '@/components/display/Contract';
import SelectDouble from '@/components/bridgeSelection/SelectDouble';
import SelectRank from '@/components/bridgeSelection/SelectRank';
import SelectPlayer from '@/components/bridgeSelection/SelectPlayer';
import FormWizard from '@/components/wizard/components/FormWizard';
import TabContent from '@/components/wizard/components/TabContent';
import {computeScore} from '@/lib/bridgeUtils';
import {post} from '@/lib/fetcher';
import {convertCardToInt, suitHtml} from "@/lib/cardSuits";
import DealStatus from "@/components/display/DealStatus.vue";

export default {
  name: 'SendResult',
  components: {
    DealStatus,
    TabContent,
    FormWizard,
    SelectPlayer,
    SelectRank,
    SelectDouble,
    Contract,
    SelectContractLevel,
    SelectSuit,
    SelectWithButtons
  },
  data() {
    return {
      confirmationTimeoutRunning: false,
      isSending: false
    };
  },
  computed: {
    ...mapGetters({
      currentTableState: 'tournament/currentTableState',
      playerCurrentSessionMap: 'players/playerCurrentSessionMap',
      currentRound: 'tournament/currentRound',
      currentContract: 'webApp/currentContract',
      currentBoard: 'webApp/currentBoard'
    }),
    isTeamNs() {
      return this.currentRoundState[0].position === 0;
    },
    isTriplicateTable() {
      return this.currentRoundState[0].triplicateTableIndex > 0;
    },
    isCurrentBoardPresentInServer() {
      return this.currentBoard != null && this.loadedBoardInThisRound.includes(this.currentBoard);
    },
    currentRoundState() {
      return this.playerCurrentSessionMap.filter(rnd => rnd.round === this.currentRound);
    },
    loadedBoardInThisRound() {
      return this.currentRoundState.flatMap(rnd => rnd.PlayedBoards);
    },
    areAllLineupsCompleted() {
      return this.currentRoundState.every(rnd => rnd.IsLineupCompleted);
    },
    convertedLeadSuit() {
      return suitHtml[this.currentContract.leadSuit] ?? '';
    },
    availableResults() {
      const ret = [];
      const level = Number(this.currentContract.level);
      for (let i = 0; i <= 13; i++) {
        const temp = i - (level + 6);
        if (temp === 0) {
          ret.push('=');
        } else if (temp > 0) {
          ret.push('+' + temp);
        } else {
          //Negative result
          ret.push(temp.toString());
        }
      }
      ret.reverse();
      return ret;
    },
    insertedResults() {
      return this.currentTableState.PlayedBoards;
    },
    missingBoards() {
      const that = this;
      const currentTableState = this.currentTableState;
      return currentTableState === null ? [] : currentTableState.Boards.filter(el =>
          !that.insertedResults.includes(el))
          .map(key => {
            return {value: key, text: key, class: ['scoreButton']};
          });
    },
    currentScore() {
      if (this.currentContract.level === 0) {
        //All pass
        return 0;
      }
      if (Object.values(this.currentContract).some(el => el === null) || this.currentBoard === null) {
        return null;
      }
      return computeScore(this.currentBoard,
          this.currentContract.level,
          this.currentContract.suit,
          this.currentContract.dbl,
          this.currentContract.declarer,
          Number.parseInt(this.currentContract.tricks)
      );
    }
  },
  watch: {
    isCurrentBoardPresentInServer: {
      handler(newValue) {
        if (newValue) {
          alert("Board arrivato da fonti esterne");
          this.resetCurrentBoard()
          this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 0)
        }
      }
    }
  },
  methods: {
    ...mapActions({
      _changeCurrentContract: 'webApp/changeCurrentContract',
      _changeCurrentBoard: 'webApp/changeCurrentBoard'
    }),
    resetCurrentBoard() {
      this._changeCurrentContract({
        "level": null,
        "suit": null,
        "dbl": null,
        "declarer": null,
        "tricks": null,
        "leadRank": null,
        "leadSuit": null
      });
      this._changeCurrentBoard(null);
    },
    sendResultToServer() {
      const contract =
          this.currentContract.level !== 0 ?
              this.currentContract.level + ' ' +
              ["C", "D", "H", "S", "NT"][this.currentContract.suit] + ' ' +
              (this.currentContract.dbl > 0 ? 'x'.repeat(this.currentContract.dbl) + ' ' : '') +
              this.currentContract.tricks :
              "PASS"

      const toBeSent = {
        board: this.currentBoard,
        table: this.currentTableState.table,
        round: this.currentTableState.round,
        serie: this.currentTableState.serie,
        room: this.currentTableState.Room,
        group: this.currentTableState.sector,
        session: this.currentTableState.session,
        declarer: this.currentContract.declarer,
        lead: convertCardToInt(this.currentContract.leadRank, this.currentContract.leadSuit),
        contract: contract
      };
      this.$nextTick(() => {
        this.isSending = true;
        post('/api/score', toBeSent)
            .then(resp => {
              if (resp.success) {
                this.resetCurrentBoard();
                this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 0)
                this.currentRoundState[0].PlayedBoards.push(toBeSent.board);
                setTimeout(() => this.isSending = false, 1000);
              } else if (!resp.validLead) {
                alert("Errore nell'inserimento, carta d'attacco non coerente");
                this.isSending = false;
              } else {
                alert("Errore nell'inserimento, lo score è già presente nel sistema");
                this.isSending = false;
              }
            });
      });
    },
    back(goto) {
      if (goto === 'boardNumber') {
        this._changeCurrentBoard(null);
        this.$refs.wizard.prevTab();
      } else if (goto === 'tricks') {
        if (this.currentContract.level === 0) {
          this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 1);
          this._changeCurrentContract({'level': null});
        } else {
          this.$refs.wizard.prevTab();
          this._changeCurrentContract({[goto]: null});
        }
      } else {
        this._changeCurrentContract({[goto]: null});
        this.$refs.wizard.prevTab();
      }
    },
    changeCurrentContract(key, value) {
      if (key === 'level' && value === 0) {
        this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 8);
      } else {
        this.$refs.wizard.nextTab();
      }
      this._changeCurrentContract({[key]: value});

      if (this.$refs.wizard.activeTabIndex === 8) {
        this.startCountdown()
      }
    },
    changeCurrentBoard(value) {
      this.$refs.wizard.nextTab();
      this._changeCurrentBoard(value);
    },
    startCountdown() {
      this.confirmationTimeoutRunning = true;
      setTimeout(() => this.confirmationTimeoutRunning = false, 5000);
    }
  },
  mounted() {
    if (this.$refs.wizard === undefined) {
      return;
    }
    if (this.currentBoard === null || this.isCurrentBoardPresentInServer) {
      this.resetCurrentBoard()
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 0);
    } else if (this.currentContract.level === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 1);
    } else if (this.currentContract.level === 0) {
      //All pass
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 8);
    } else if (this.currentContract.suit === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 2);
    } else if (this.currentContract.dbl === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 3);
    } else if (this.currentContract.declarer === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 4);
    } else if (this.currentContract.leadRank === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 5);
    } else if (this.currentContract.leadSuit === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 6);
    } else if (this.currentContract.tricks === null) {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 7);
    } else {
      this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 8);
    }
  }
};
</script>
<style scoped>
* {
  text-align: center;
}

.button {
  font-size: 5vw;
}

.scoreResume {
  font-size: 30vw;
}

.scoreResumeForNS {
  color: #2661CE;
}

.scoreResumeForEW {
  color: #DC143C;
}

.scoreResumePass {
  color: green;
}

.boardResume {
  font-size: 10vw;
}

/deep/ .lead ._htmlSuiteClass {
  font-size: 13vw;
}


.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
  font-size: 1.2rem;
}


>>> .scoreButton {
  background: white;
  border: 1px solid #3396B8;
}

.backButton {
  display: inline-block;
  font-size: 140%;
  transform: rotate(180deg);
}

.cannotSendResult {
  font-size: 140%;
}
</style>

